import {useListView} from '../core/ListViewProvider'
import {BookingExtraListToolbar} from './BookingExtraListToolbar'
import {BookingExtraListGrouping} from './BookingExtraListGrouping'
import {BookingExtraListSearchComponent} from './BookingExtraListSearchComponent'

const BookingExtraListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <BookingExtraListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <BookingExtraListGrouping /> : <BookingExtraListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {BookingExtraListHeader}
